const DAYS = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

function getDeliveryDate() {
  let date = new Date();
  date.setHours(0, 0, 0, 0);
  let businessDaysAdded = 0;
  while (businessDaysAdded < 7) {
    date.setDate(date.getDate() + 1);
    const dow = date.getDay();
    if (dow !== 0 && dow !== 6) businessDaysAdded++;
  }
  return `${DAYS[date.getDay()]}, ${MONTHS[date.getMonth()]} ${date.getDate()}`;
}

document.addEventListener('DOMContentLoaded', function() {
  const claimBar = document.getElementById('claim-bar');
  const faqSection = document.querySelector('.aestetia-faq-question');

  const dateEl = document.getElementById('claim-bar-date');
  if (dateEl) dateEl.textContent = getDeliveryDate();
  const glowSections = [
    'shopify-section-template--19887962652888__custom_liquid_MaDpF6',
    'shopify-section-template--19887962652888__custom_liquid_dgbe4E',
    'shopify-section-template--19887962652888__custom_liquid_Ri3VQn'
  ].map(id => document.getElementById(id)).filter(Boolean);
  if (glowSections.length) {
    const glowState = new Map();
    const glowObserver = new IntersectionObserver((entries) => {
      entries.forEach(e => glowState.set(e.target, e.isIntersecting));
      const anyVisible = Array.from(glowState.values()).some(Boolean);
      claimBar.classList.toggle('claim-bar--glow', anyVisible);
    }, { rootMargin: '0px 0px -100px 0px' });
    glowSections.forEach(s => { glowState.set(s, false); glowObserver.observe(s); });
  }

  claimBar.style.transition = 'transform 0.5s ease, box-shadow 0.4s ease';
  claimBar.style.transform = 'translateY(100%)';

  const footer = document.querySelector('.footer-container');
  let footerInView = false;

  function updateClaimBarVisibility() {
    const faqBottom = faqSection.getBoundingClientRect().bottom + window.scrollY;
    if (window.scrollY > faqBottom && !footerInView) {
      claimBar.style.transform = 'translateY(0)';
    } else {
      claimBar.style.transform = 'translateY(100%)';
    }
  }

  if (footer) {
    new IntersectionObserver((entries) => {
      footerInView = entries[0].isIntersecting;
      updateClaimBarVisibility();
    }, { threshold: 0 }).observe(footer);
  }

  window.addEventListener('scroll', updateClaimBarVisibility);

  var claimBtn = document.querySelector('.claim-bar-button');
  var productSection = document.getElementById('shopify-section-template--19887962652888__featured_product_Ajfh9k');
  if (claimBtn && productSection) {
    claimBtn.removeAttribute('onclick');
    claimBtn.addEventListener('click', function(e) {
      e.preventDefault();
      productSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
});

